import React from "react";

const TestimonialsSection = () => {
  // Array of customer reviews
  const testimonials = [
    {
      id: 1,
      name: "Sarah Jenkins",
      role: "Freelance Designer",
      plan: "Streamer Plan",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      review:
        "The upload speeds are insane. I can upload 4GB files in minutes. Finally, an ISP that understands bandwidth needs.",
    },
    {
      id: 2,
      name: "Mike Ross",
      role: "Pro Gamer",
      plan: "Gamer Plan",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      review:
        "My ping dropped from 80ms to 5ms. I went from 'Noob' to 'Pro' in a week just because my connection stopped lagging.",
    },
    {
      id: 3,
      name: "Emily Chen",
      role: "Mom of 3",
      plan: "Starter Plan",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      review:
        "Super reliable. We have 3 kids streaming, gaming, and doing homework simultaneously, and we never hit a buffer. Installation was free too!",
    },
  ];

  return (
    <section className="py-24 bg-slate-50 text-slate-900">
      <div className="container mx-auto px-6 max-w-screen-xl">
        {/* --- Section Header --- */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-blue-600 font-bold tracking-wider uppercase text-xs">
            Trusted by 10,000+ Users
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-4 text-slate-900">
            What Our Customers Say
          </h2>
          <p className="text-slate-600">
            Real people, real speeds. Don't just take our word for it.
          </p>
        </div>

        {/* --- Testimonials Grid --- */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((item) => (
            <TestimonialCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

// --- Reusable Testimonial Card Component ---
const TestimonialCard = ({ item }) => (
  <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-xl transition-all duration-300 relative">
    {/* Quote Icon */}
    <div className="absolute top-6 right-6 text-slate-200 text-4xl font-serif">
      "
    </div>

    {/* Customer Info */}
    <div className="flex items-center gap-4 mb-6">
      <img
        src={item.image}
        alt={item.name}
        className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-md"
      />
      <div>
        <h4 className="font-bold text-slate-900 text-lg">{item.name}</h4>
        <span className="text-xs text-blue-600 font-semibold uppercase tracking-wider">
          {item.role} • {item.plan}
        </span>
      </div>
    </div>

    {/* Review Text */}
    <p className="text-slate-600 leading-relaxed relative z-10">
      {item.review}
    </p>

    {/* Stars (Static for design) */}
    <div className="flex gap-1 mt-6 text-yellow-400">
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    </div>
  </div>
);

export default TestimonialsSection;
